import BaseDrawerFeature from '@framework/workbench/common/feature/base-drawer-feature';
import { opacityToAlpha } from '@framework/workbench/drawer/utils';
import { getColorRGB } from '@src/slide/infrastructure/module/independent/color/transform';

export class BaseFill extends BaseDrawerFeature {
    public updateFillProps = (value, onlyChangeUI?) => {
    };

    public getOpacityChangedColor = (opacity: number, color: string) => {
        const alpha = opacityToAlpha(opacity) ?? 1;
        const rgb = getColorRGB(color);
        return `rgb(${rgb[0]},${rgb[1]},${rgb[2]},${alpha})`;
    };
}
